import type { NextPage } from 'next';
import { Layout, Policy } from 'ui';
import useUser from '../auth/useUser';
import theme from '../styles/theme';
import { Grid } from '@mui/material';
import CompanyButton from '../components/common/CompanyButton';
import Image from 'next/image';
import logoEfigas from '../public/img/Logo_efigas_full.svg';
import logoGascaribe from '../public/img/Logo_Gases_Two_lines.svg';
import logoGuajira from '../public/img/Logo_gases_guajira_full.svg';
import { AppLogo } from '../components/common/AppLogo';

const Home: NextPage = () => {
  const user = useUser();
  return (
    <Layout
      pageTitle="Atlas"
      userName={user?.name}
      customMainStyle={{
        top: '60px',
        minWidth: '410px',
        padding: theme.spacing(2),
      }}
      customHeaderStyle={{
        borderBottom: '1px solid #eeeeee',
        opacity: 1,
      }}
      customButtonsAsideStyle={{ height: 72 }}
      enabledUserIcon={true}
      userLogout={user?.actions?.logout}
      enableGasesIcon={false}
      customIconApp={<AppLogo height="50px" width="50px" />}
      customTitleStyle={{
        fontWeight: 800,
        textTransform: 'uppercase',
      }}
    >
      <Grid
        container
        display="flex"
        direction="column"
        alignItems="center"
        sx={{
          marginTop: theme.spacing(5),
          marginleft: 'auto',
          marginRight: 'auto',
        }}
      >
        <Policy user={user} roles={['atlas-gascaribe']}>
          <Grid>
            <CompanyButton link="/gascaribe">
              <Image src={logoGascaribe} alt="Gascaribe" width={230} />
            </CompanyButton>
          </Grid>
        </Policy>
        <Policy user={user} roles={['atlas-efigas']}>
          <Grid>
            <CompanyButton link="/efigas">
              <Image src={logoEfigas} alt="Efigas" width={230} />
            </CompanyButton>
          </Grid>
        </Policy>
        <Policy user={user} roles={['atlas-gasguajira']}>
          <Grid>
            <CompanyButton link="/gasguajira">
              <Image src={logoGuajira} alt="Gasguajira" width={230} />
            </CompanyButton>
          </Grid>
        </Policy>
      </Grid>
    </Layout>
  );
};

export default Home;
